// FILE: src/features/feedbackSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWithAuth from "../utils/fetchWithAuth";

// Fetch all feedback (optionally filtered by rating/date)
export const fetchFeedback = createAsyncThunk(
  "feedback/fetchFeedback",
  async ({ rating, startDate, endDate }) => {
    const params = new URLSearchParams();
    if (rating) params.set("rating", rating);
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);

    // Provide only the relative path to fetchWithAuth
    const url = `/api/feedback?${params.toString()}`;
    return await fetchWithAuth(url);
  }
);

// Fetch a single feedback item by ID
export const fetchSingleFeedback = createAsyncThunk(
  "feedback/fetchSingleFeedback",
  async (id) => {
    const url = `/api/feedback/${id}`;
    return await fetchWithAuth(url);
  }
);

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    list: [],
    loading: false,
    error: null,
    currentFeedback: null // For detail view
  },
  reducers: {
    clearCurrentFeedback(state) {
      state.currentFeedback = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchFeedback
      .addCase(fetchFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // fetchSingleFeedback
      .addCase(fetchSingleFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentFeedback = null;
      })
      .addCase(fetchSingleFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.currentFeedback = action.payload;
      })
      .addCase(fetchSingleFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.currentFeedback = null;
      });
  }
});

export const { clearCurrentFeedback } = feedbackSlice.actions;
export default feedbackSlice.reducer;
